import r from "styled-components";
const p = r.div``, n = r(p)`
  margin-bottom: 18px;
`, o = r(p)`
  padding: 3rem;
`;
export {
  p as BaseWrapper,
  n as HeadingWrapper,
  o as SpinnerWrapper
};
